import { all } from "@redux-saga/core/effects";
import { publishRequestSagas } from "modules/ConfigCI/services/PublishRequests/sagas";
import { configCITestsSagas } from "modules/ConfigCI/services/ConfigCITests/sagas";
import { reportCaseSagas } from "modules/ConfigCI/services/ReportCase/sagas";

export function* configCISaga() {
    yield all([
        publishRequestSagas(),
        configCITestsSagas(),
        reportCaseSagas()
    ]);
}
